import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';

import styles from './overlay.module.scss';

/**
 * Component covering the whole viewport except the header.
 *
 * Is rendered within a special portal so it's always on top.
 */
function Overlay<Tag extends keyof JSX.IntrinsicElements = 'div'>({
  as,
  overlayKey,
  children,
  className,
  ...props
}: {
  readonly as?: Tag;
  readonly overlayKey: string | number;
} & JSX.IntrinsicElements[Tag]) {
  const overlayRoot = useMemo(
    () =>
      typeof document !== 'undefined'
        ? document.getElementById('overlay-root')
        : null,
    [],
  );

  const overlay = React.createElement(
    as ?? 'div',
    {
      className: cn(styles.overlay, className),
      ...props,
    },
    children as React.ReactNode,
  );

  return overlayRoot
    ? createPortal(overlay, overlayRoot, overlayKey.toString())
    : overlay;
}

export default Overlay;
